import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from 'styled-components';
import {
  getTestData,
  downloadTestData
} from "store/state/calculators/testHarness";
import numberFormatter from 'utils/numberFormatter';
import { TableHead, TableBody, TableRow, TableFooter, TablePagination } from "@material-ui/core";
import shortid from "shortid";

import {  
  StyledHeaderCell,
  StyledTableCell,
  StyledTable,
  StyledTableRow
} from "../../Constants/StyledComponents";
import TablePaginationHelper from "../../../../utils/tablePaginationHelper";

const ThinHeaderCell = styled(StyledHeaderCell)`
  &&& {
    min-width:50px;
  }
`
const ThinTableCell = styled(StyledTableCell)`
  &&& {
    min-width:50px;
  }
`

class AmortResultTable extends Component {
  tablePaginationHelper = new TablePaginationHelper("e52dd1f6-33a8-4e8f-bd70-84fefa95a725");

  createHeaderRow = () => (
    <StyledTableRow key={shortid.generate()}>
      <ThinHeaderCell >Period</ThinHeaderCell>
      <ThinHeaderCell>Begin Date</ThinHeaderCell>
      <ThinHeaderCell>End Date</ThinHeaderCell>   
      <ThinHeaderCell>Begin Principal Balance</ThinHeaderCell>    
      <ThinHeaderCell>Interest</ThinHeaderCell>
      <ThinHeaderCell>Interest Rate</ThinHeaderCell>
      <ThinHeaderCell>Principal</ThinHeaderCell>
      <ThinHeaderCell>Payment</ThinHeaderCell>   
      <ThinHeaderCell>End Principal Balance</ThinHeaderCell>    
    </StyledTableRow>  
  );

  createAmortizationRow = item => {
    return (
    <StyledTableRow key={shortid.generate()} hover>
      <ThinTableCell > {item.period}</ThinTableCell>
      <ThinTableCell> {item.beginDate}</ThinTableCell>
      <ThinTableCell > {item.endDate}</ThinTableCell>
      <ThinTableCell > {numberFormatter.formatMoney(item.beginPrincipalBalance)}</ThinTableCell>    
      <ThinTableCell > {numberFormatter.formatMoney(item.interest)}</ThinTableCell>
      <ThinTableCell > {numberFormatter.formatRate(item.interestRate)}</ThinTableCell>
      <ThinTableCell > {numberFormatter.formatMoney(item.principal)}</ThinTableCell>
      <ThinTableCell > {numberFormatter.formatMoney(item.payment)}</ThinTableCell>
      <ThinTableCell > {numberFormatter.formatMoney(item.endPrincipalBalance)}</ThinTableCell>
     </StyledTableRow>  
    )
  };
  
  mapTableData = testData => {
    if (testData) {
      return testData.PagedList.map(item => (        
          this.createAmortizationRow(item)
      ));
    }
    return (
      <StyledTableRow key={shortid.generate()} hover>
        <ThinTableCell/>
        <ThinTableCell />
      </StyledTableRow>
    );
  };

  render() {    
    const rowsPerPage = this.tablePaginationHelper.rowsPerPage;
    const page = this.tablePaginationHelper.page;
    const {
      testHarness: { testData },
      count
    } = this.props;

    if (!testData || !testData.PagedList) return null;        

    return (
      <Fragment>
        <StyledTable height={20} className="tableBlueHover">
          <TableHead>
            {this.createHeaderRow()}            
          </TableHead>
          <TableBody>{this.mapTableData(testData || [])}</TableBody>
          <TableFooter>
            <TableRow >
              <TablePagination
                count={count}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 1000]}
                page={page}
                backIconButtonProps={{
                  "aria-label": "Previous Page"
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page"
                }}
                onChangePage={this.props.handleChangePage}
                onChangeRowsPerPage={this.props.handleChangeRowsPerPage}
                labelDisplayedRows={() => `${page + 1} of ${Math.ceil(count / rowsPerPage)}`}
              />
            </TableRow>
          </TableFooter>
        </StyledTable>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ testHarness }) => ({
  testHarness,
  count: testHarness.testData ? testHarness.testData.ListCount : 1
});

export default compose(
  connect(
    mapStateToProps,
    { getTestData, downloadTestData }
  )
)(AmortResultTable);
